import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * 路由必须添加name属性，并且保证路由中的name属性和vue文件中的name属性一致
 */
export const constantRoutes = [{
		path: '',
		redirect: 'indexJump'
	},
	{//登录进来首先到跳转页，在跳转页面进行登录等一系列操作，完成之后，在到/main/index
		path: '/indexJump',
		name: 'IndexJump',
		component: (resolve) => require(['@/views/main/indexJump'], resolve),
	},
	{
		path: '/main',
		name: 'Main',
		component: (resolve) => require(['@/views/main2'], resolve),
		redirect: 'main/index',
		children: [{
				path: 'index',
				name: 'MainIndex',
				component: (resolve) => require(['@/views/main/Index2'], resolve)
			},
			{ //首页-法律法规政策-详情
				path: 'main/flfgzcDetail',
				name: 'MainIndexFlfgzcDetail',
				component: (resolve) => require(['@/views/main/zhengce_detail'], resolve)
			},
			{ //首页-党建引领-表彰通报-详情
				path: 'main/xwqyczDjylBztb/detail/:recid',
				name: 'MainIndexDjylBztbDetail',
				component: (resolve) => require(['@/views/main/djyl_bztb_detail'], resolve)
			},
			{ //知识产权综合服务-法律法规政策
				path: 'zscqzhfw/flfgzc',
				name: 'MainFlfgzc',
				component: (resolve) => require(['@/views/main/zscqzhfw/flfg/flfg'], resolve)
			},
			{ //知识产权综合服务-法律法规政策-详情
				path: 'zscqzhfw/flfgzc/detail/:recid',
				name: 'MainFlfgDetail',
				component: (resolve) => require(['@/views/main/zscqzhfw/flfg/detail'], resolve)
			},
			{ //知识产权超市
				path: 'zscqzhfw/zscqcs',
				name: 'MainZscqcs',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqmarket/zscqcs'], resolve)
			},
			{ //知识产权超市-详情
				path: 'zscqzhfw/zscqcsDetail/:recid',
				name: 'zscqcsDetail',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqmarket/zscqcsDetail'], resolve)
			},
			{ //知识产权超市-新增
				path: 'zscqzhfw/zscqcsRecord',
				name: 'zscqcsRecord',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqmarket/zscqcsRecord'], resolve)
			},
			{ //知识产权超市-新增
				path: 'zscqzhfw/zscqzyzh',
				name: 'zscqzyzh',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqzyzh/index'], resolve)
			},
			{ //申办事项查询编辑-知识产权超市-新增
				path: 'zscqzhfw/zscqcsRecord/:recid',
				name: 'zscqcsRecord',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqmarket/zscqcsRecord'], resolve)
			},
			{ //京鲁慧一键通览
				path: 'zscqzhfw/jlhyjtl',
				name: 'jlhyjtl',
				component: (resolve) => require(['@/views/main/zscqzhfw/jlhyjtl/jlhyjtl'], resolve)
			},
			{ //质量提升综合服务-计量服务
				path: 'zltszhfw/jlfw',
				name: 'MainJlfw',
				component: (resolve) => require(['@/views/main/zltszhfw/jlfw/jlfw'], resolve)
			},
			{ //质量提升综合服务-计量服务-威海市计量授权机构查询
				path: 'zltszhfw/jlfw/whsjlsqjgcx',
				name: 'MainWhsjlsqjgcx',
				component: (resolve) => require(['@/views/main/zltszhfw/jlfw/whsjlsqjgcx'], resolve)
			},
			{ //质量提升综合服务-标准服务
				path: 'zltszhfw/bzfw',
				name: 'MainBzfw',
				component: (resolve) => require(['@/views/main/zltszhfw/standard/standard'], resolve)
			},
			{ //质量提升综合服务-标准服务-威海地方标准-详情
				path: 'zltszhfw/bzfw/detail/:recid',
				name: 'MainBzfwDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/standard/detail'], resolve)
			},
			{ //质量提升综合服务-标准服务-“一对一”定制式标准化技术服务-申请
				path: 'zltszhfw/bzfw/apply',
				name: 'MainBzfwApply',
				component: (resolve) => require(['@/views/main/zltszhfw/standard/apply'], resolve)
			},
			{ //申办事项查询-“一对一”定制式标准化技术服务-申请
				path: 'bzfw/apply/:recid',
				name: 'MainBzfwApply',
				component: (resolve) => require(['@/views/main/zltszhfw/standard/apply'], resolve)
			},
			{//质量提升综合服务-认证服务
			    path: 'zltszhfw/rzfw',
			    name:'Rzfw',
			    component: (resolve) => require(['@/views/main/zltszhfw/rzfw'], resolve)
			},
			{//质量提升综合服务-认证服务-通知公告详情
				path: 'zltszhfw/rzfw/tzggDetail',
				name:'RzfwTzggDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/rzfw/detail'], resolve)
			},
			{//质量提升综合服务-认证服务-三同企业发布详情
				path: 'zltszhfw/rzfw/StqyFbDetail',
				name:'RzfwTzggDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/rzfw/stqyFbDetail'], resolve)
			},
			{//质量提升综合服务-质量与品牌
			    path: 'zltszhfw/zlypp',
			    name:'zlypp',
			    component: (resolve) => require(['@/views/main/zltszhfw/zlypp'], resolve)
			},
			{//质量提升综合服务-质量与品牌-通知公告-详情
				path: 'zltszhfw/zlypp/detail/:recid',
				name:'zlyppDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/zlypp/detail'], resolve)
			},
			{ //质押融资服务
				path: 'zscqzhfw/zyrzfw',
				name: 'zyrzfw',
				component: (resolve) => require(['@/views/main/zscqzhfw/zyrzfw/index'], resolve)
			},
			{ //办事指南
				path: 'zscqzhfw/zyrzfwBszn',
				name: 'zyrzfwBszn',
				component: (resolve) => require(['@/views/main/zscqzhfw/zyrzfw/bszn'], resolve)
			},
			{ //申报
				path: 'zscqzhfw/zyrzfwSb',
				name: 'zyrzfwSb',
				component: (resolve) => require(['@/views/main/zscqzhfw/zyrzfw/sb'], resolve)
			},
			{ //申办事项查询-申报
				path: 'zscqzhfw/zyrzfwSb/:recid',
				name: 'zyrzfwSb',
				component: (resolve) => require(['@/views/main/zscqzhfw/zyrzfw/sb'], resolve)
			},
			{ //威海专利
				path: 'zscqzhfw/whszl',
				name: 'whszl',
				component: (resolve) => require(['@/views/main/zscqzhfw/whszl/index'], resolve)
			},
			{//质量提升综合服务-质量基础设施服务中心（平台）
				path: 'zltszhfw/zljcss',
				name:'zljcss',
				component: (resolve) => require(['@/views/main/zltszhfw/zljcss'], resolve)
			},
			{
				path: 'xwqyczfw/xwqycx',
				name: 'Xwqycx',
				component: (resolve) => require(['@/views/main/xwqyczfw/xwqycx/index'], resolve)
			},
			{ //小微企业成长服务-党建引领
				path: 'xwqyczfw/djyl',
				name: 'MainDjyl',
				component: (resolve) => require(['@/views/main/xwqyczfw/djyl/djyl'], resolve)
			},
			{ //小微企业成长服务-党建引领-详情
				path: 'xwqyczfw/djyl/detail/:djyltype/:recid',
				name: 'MainDjylDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/djyl/detail'], resolve)
			},
			{ //小微企业成长服务-党建引领撤销-详情
				path: 'xwqyczfw/djyl/cxdetail/:djyltype/:recid',
				name: 'MainDjylCxDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/djyl/cxdetail'], resolve)
			},
			{ //小微企业成长服务-文明诚信引领
				path: 'xwqyczfw/wmcxyl',
				name: 'MainWmcxyl',
				component: (resolve) => require(['@/views/main/xwqyczfw/wmcxyl/wmcxyl'], resolve)
			},
			{ //小微企业成长服务-文明诚信引领-详情
				path: 'xwqyczfw/wmcxyl/detail/:type/:recid',
				name: 'MainWmcxylDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/wmcxyl/detail'], resolve)
			},
			{ //小微企业成长服务-文明诚信引领活动-详情
				path: 'xwqyczfw/wmcxyl/hddetail/:type/:recid',
				name: 'MainWmcxylHdDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/wmcxyl/hddetail'], resolve)
			},
			{ //检验检测服务-产品质量检测
				path: 'jyjcfw/cpzljc',
				name: 'MainCpzljc',
				component: (resolve) => require(['@/views/main/jyjcfw/cpzljc/cpzljc'], resolve)
			},
			{ //申办事项查询-产品质量检测
				path: 'jyjcfw/cpzljc/:recid',
				name: 'MainCpzljc',
				component: (resolve) => require(['@/views/main/jyjcfw/cpzljc/cpzljc'], resolve)
			},
			{ //检验检测服务-特种设备检测
				path: 'jyjcfw/tzsbjc',
				name: 'MainTzsbjc',
				component: (resolve) => require(['@/views/main/jyjcfw/tzsbjc/tzsbjc'], resolve)
			},
			{ //检验检测服务-特种设备检测-考试通知公告
				path: 'jyjcfw/tzsbjc/detail/:recid',
				name: 'MainTzsbjcDetail',
				component: (resolve) => require(['@/views/main/jyjcfw/tzsbjc/detail'], resolve)
			},
			{ //在线咨询-form表单
				path: 'zxzxForm',
				name: 'zxzxForm',
				component: (resolve) => require(['@/views/main/zxzx/index'], resolve)
			},
			{ //招聘需求发布-form表单
				path: 'xwqyczfw/zpxqfbForm',
				name: 'zpxqfbForm',
				component: (resolve) => require(['@/views/main/xwqyczfw/rcdj/zpxqfb'], resolve)
			},
			{ //申办事项查询-招聘需求发布-form表单
				path: 'xwqyczfw/zpxqfbForm/:recid',
				name: 'zpxqfbForm',
				component: (resolve) => require(['@/views/main/xwqyczfw/rcdj/zpxqfb'], resolve)
			},
			{ //知识产权服务联盟-服务联盟简介
				path: 'zscqzhfw/fwlmjj',
				name: 'fwlmjj',
				component: (resolve) => require(['@/views/main/zscqzhfw/zscqfwlm/fwlmjj'], resolve)
			},
			{ //小微企业成长服务-融资服务
				path: 'xwqyczfw/rzfw',
				name: 'xwqyRzfw',
				component: (resolve) => require(['@/views/main/xwqyczfw/rzfw/index'], resolve)
			},
			{ //小微企业成长服务-融资服务-详情
				path: 'xwqyczfw/rzfw/detail',
				name: 'xwqyRzfwDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/rzfw/detail'], resolve)
			},
			{ //小微企业成长服务-小微企业融资需求申请
				path: 'xwqyczfw/xqsq',
				name: 'xwqyXqsq',
				component: (resolve) => require(['@/views/main/xwqyczfw/rzfw/xqsq'], resolve)
			},
			{ //申办事项查询-小微企业成长服务-小微企业融资需求申请
				path: 'xwqyczfw/xqsq/:recid',
				name: 'xwqyXqsq',
				component: (resolve) => require(['@/views/main/xwqyczfw/rzfw/xqsq'], resolve)
			},

			{ //3D会客大厅
				path: 'hkdt',
				name: 'hkdt',
				component: (resolve) => require(['@/views/main/hkdt'], resolve)
			},

			{ //小微企业成长服务-惠企政策
				path: 'xwqyczfw/hqzc',
				name: 'xwqyHqzc',
				component: (resolve) => require(['@/views/main/xwqyczfw/hqzc/index'], resolve)
			},
			{ //小微企业成长服务-详情
				path: 'xwqyczfw/hqzcDetail/:recid',
				name: 'hqzcDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/hqzc/hqzcDetail'], resolve)
			},
			{ //小微企业成长服务-法律维权典型案例与分析
				path: 'xwqyczfw/flwqdxalyfx',
				name: 'flwqdxalyfx',
				component: (resolve) => require(['@/views/main/xwqyczfw/flwqdxalyfx/index'], resolve)
			},
			{ //小微企业成长服务-法律维权典型案例与分析-详情
				path: 'xwqyczfw/flwqdxalyfxDetail/:recid',
				name: 'flwqdxalyfxDetail',
				component: (resolve) => require(['@/views/main/xwqyczfw/flwqdxalyfx/detail'], resolve)
			},
			{ //小微企业成长服务-人才对接
				path: 'xwqyczfw/rcdj',
				name: 'xwqyRcdj',
				component: (resolve) => require(['@/views/main/xwqyczfw/rcdj/index'], resolve)
			},
			{ //质量提升综合服务-培训服务
				path: 'zltszhfw/pxfw',
				name: 'xwqyPxfw',
				component: (resolve) => require(['@/views/main/zltszhfw/pxfw/index'], resolve)
			},
			{ //质量提升综合服务-培训服务-详情
				path: 'zltszhfw/pxfw/detail',
				name: 'pxfwDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/pxfw/detail'], resolve)
			},
			{ //质量提升综合服务-培训服务-海外信息发布详情
				path: 'zltszhfw/pxfw/hwxxfbDetail',
				name: 'hwxxfbDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/pxfw/hwxxfbDetail'], resolve)
			},
			{ //质量提升综合服务-培训服务-视频详情
				path: 'zltszhfw/pxfw/vedioDetail',
				name: 'pxfwVedioDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/pxfw/vedioDetail'], resolve)
			},
            {//小微企业成长服务-人才对接-企业招聘详情
                path: 'xwqyczfw/rcdj/qyzpxxDetail/:recid',
                name:'qyzpxxDetail',
                component: (resolve) => require(['@/views/main/xwqyczfw/rcdj/qyzpxxDetail'], resolve)
            },
			{//NQI服务-医疗器械创新
			    path: 'zltszhfw/ylqxcx',
			    name:'Ylqxcx',
			    component: (resolve) => require(['@/views/main/zltszhfw/ylqxcx/index'], resolve)
			},
			{ //NQI服务-医疗器械创新-详情
				path: 'zltszhfw/ylqxcx/detail/:recid',
				name: 'MainFlfgDetail',
				component: (resolve) => require(['@/views/main/zltszhfw/ylqxcx/zcfg/detail'], resolve)
			},
		]
	},

	{
		path: '/hkdt',
		name: 'Hkdt',
		component: (resolve) => require(['@/views/hkdt'], resolve),

	},
	{
		path: '/qygzs',
		name: 'Qygzs',
		component: (resolve) => require(['@/views/qygzs'], resolve),
		redirect: 'qygzs/index',
		children: [{
			path: 'index',
			name: 'QygzsIndex',
			component: (resolve) => require(['@/views/qygzs/index'], resolve)
		}, ]
	},
	{
		path: '/401',
		name: 'Page401',
		component: (resolve) => require(['@/views/error/401'], resolve)
	},
	{
		path: '/404',
		name: 'Page404',
		component: (resolve) => require(['@/views/error/404'], resolve)
	},
]

export default new Router({
	mode: 'history', // 去掉url中的#
	base:'/service/',//打包发布二级页面时放开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})
